import {BaseResponseMessage, ErrorResponseMessage} from "../commands";
import {MeUser, Sex} from "../user";
import {ClientSettingsModel} from "../client.settings";
import {Errors} from "../errors";

export namespace ConnectCommandNamespace {
    export const COMMAND_CONNECT = 'connect';
    export const NOTIFICATION_UNPAID_ROOM = 'UNPAID_ROOM';
    export const NOTIFICATION_LOW_BALANCE_UPCOMING_CHARGE = 'LOW_BALANCE_UPCOMING_CHARGE';
    export const NOTIFICATION_PM_SETTING_RESET = 'PM_SETTING_RESET';
    /** metadata: `{count: number, senders: string[]}` — число непрочитанных писем и до 3 отправителей. */
    export const NOTIFICATION_UNREAD_LETTERS = 'UNREAD_LETTERS';
    /** metadata: `MaintenanceNamespace.State` — идёт режим технических работ (входят только привилегированные). */
    export const NOTIFICATION_MAINTENANCE = 'MAINTENANCE';

    export interface ImageServer {
        subdomain?: string;
        priority: number;
    }

    export interface ExtraInfo {
        paid_room_price_cents: number;
        buy_premium_enabled: boolean;
        premium_price_cents: number;
        image_servers?: Array<ImageServer>;
        telegram_stars_enabled: boolean;
        digiseller_enabled: boolean;
        letters_enabled: boolean;
    }

    export interface ConnectNotification {
        type: string;
        metadata?: any;
    }

    export class Response extends BaseResponseMessage {
        constructor(override readonly id: number, readonly user: MeUser, readonly session: string, readonly settings: ClientSettingsModel, readonly extra: ExtraInfo, readonly notifications: Array<ConnectNotification>) {
            super(COMMAND_CONNECT, id, true);
        }
    }

    export class ConnectCommandError extends ErrorResponseMessage {
        constructor(override readonly id: number, error: Errors) {
            super(COMMAND_CONNECT, id, error);
        }
    }

    export class PasswordRequiredError extends ErrorResponseMessage {
        constructor(override readonly id: number, readonly login: string, readonly sex: Sex, readonly showInvisibleButton: boolean) {
            super(COMMAND_CONNECT, id, Errors.PASSWORD_REQUIRED);
        }
    }

    export class UserBlockedResponse extends ErrorResponseMessage {
        constructor(override readonly id: number, readonly willBeUnblockThrough: number, readonly message: string) {
            super(COMMAND_CONNECT, id, Errors.USER_IS_BLOCKED);
        }

        static PERMANENT_UNBLOCK_TIME = -1
    }

    export class AuthBlockedResponse extends ErrorResponseMessage {
        constructor(override readonly id: number, readonly willBeUnblockThrough: number) {
            super(COMMAND_CONNECT, id, Errors.ENTERS_ATTEMPTS_EXCEEDED);
        }
    }
}
